import { render, staticRenderFns } from "./digestion.vue?vue&type=template&id=66242776&"
import script from "./digestion.vue?vue&type=script&lang=js&"
export * from "./digestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports